/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const TicketType = {
  Question: "Question",
  SoftwareIssue: "Software Issue",
  FeatureRequest: "Feature Request",
  Billing: "Billing",
  Documentation: "Documentation",
  Other: "Other",
} as const;
export type TicketType = (typeof TicketType)[keyof typeof TicketType];

export function TicketTypeFromJSON(json: any): TicketType {
  return TicketTypeFromJSONTyped(json);
}

export function TicketTypeFromJSONTyped(json: any): TicketType {
  return json as TicketType;
}

export function TicketTypeToJSON(value?: TicketType | null): any {
  return value as any;
}
